import React from 'react'
import { css, cx } from '@emotion/css'
import { theme as deprecatedTheme } from '../../styled'
import { theme } from '@contrast-security-inc/design-system-foundations'
import { Dropdown } from '../dropdown'
import { DropdownProps, DropdownStyleOverrides } from '../dropdown/dropdown'

export const height = 23.0
export const borderRadius = height / 2

const textCss = css`
  font-family: ${deprecatedTheme.fontFamilies.primaryCondensed};
  font-weight: 400;
  color: ${theme.color.neutral80};
  text-transform: uppercase;
  letter-spacing: 0.01em;
  font-size: 12px;
`

const getStyleOverrides = (
  roundedCorners: DropdownRoundedCornersType
): DropdownStyleOverrides => {
  const isAllCornersRounded = roundedCorners === 'all'

  return {
    outerContainerCss: css`
      width: 170px;
    `,
    selectionContainerCss: css`
      background-color: ${theme.color.neutral20};
      background-image: none;
      border: none;
      border-radius: ${isAllCornersRounded ? borderRadius : '0'}px
        ${borderRadius}px ${borderRadius}px
        ${isAllCornersRounded ? borderRadius : '0'}px;
      height: ${height}px;
      padding: 0px 8px 0px 10px;
    `,
    selectionOpenContainerCss: css`
      border-bottom-right-radius: 0;
      border-bottom-left-radius: 0;
    `,
    menuCss: css`
      background-color: ${theme.color.neutral20};
      border: none;
      border-radius: 0 0 ${borderRadius}px ${borderRadius}px;
      padding: 0 0 5px;
      box-shadow: 1px 5px 10px -2px ${theme.color.neutral50};
    `,
    menuItemContainerCss: css`
      background-color: ${theme.color.neutral20};
      padding: 6px 10px;
    `,
    menuItemActiveContainerCss: css`
      background-color: ${theme.color.white};
    `,
    arrowColor: 'neutral60',
    selectionTextCss: cx(
      textCss,
      css`
        padding: 0;
      `
    ),
    menuItemTextCss: cx(
      textCss,
      css`
        color: ${theme.color.neutral60};
      `
    ),
    menuItemSelectedTextCss: css`
      font-weight: normal;
      color: ${theme.color.neutral100};
    `
  }
}

type DropdownRoundedCornersType = 'all' | 'right'

interface OrderDropdownProps<T> extends DropdownProps<T> {
  readonly roundedCorners?: DropdownRoundedCornersType
}

export function OrderDropdown<T>({
  roundedCorners = 'all',
  ...props
}: OrderDropdownProps<T>) {
  return (
    <Dropdown {...props} styleOverrides={getStyleOverrides(roundedCorners)} />
  )
}
